var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    { ref: "modal", attrs: { heading: "Recycle Applicant" } },
    [
      _c("h1", [
        _vm._v("Recycling " + _vm._s(_vm.jobApplication.user.full_name))
      ]),
      _vm._v(" "),
      _c(
        "form",
        {
          attrs: {
            method: "POST",
            action:
              "/recruiter/active-requisitions/recycle/" +
              _vm.jobApplication.id +
              "?from=" +
              this.from +
              "&requisition_id=" +
              this.requisitionId
          }
        },
        [
          _c("input", {
            attrs: { type: "hidden", name: "_csrfToken" },
            domProps: { value: _vm.csrfToken }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mb-4" },
            [
              _c("label", [_vm._v("Pick Job")]),
              _vm._v(" "),
              _c("input", {
                attrs: { name: "job_id", type: "hidden" },
                domProps: { value: _vm.recycleJob ? _vm.recycleJob.id : null }
              }),
              _vm._v(" "),
              _c("input", {
                attrs: { name: "reason", type: "hidden" },
                domProps: { value: _vm.reason ? _vm.reason : null }
              }),
              _vm._v(" "),
              _c("vue-select", {
                attrs: { label: "title", options: _vm.requisitionJobs },
                on: {
                  search: _vm.fetchRequisitionJobs,
                  open: _vm.fetchRequisitionJobs
                },
                scopedSlots: _vm._u([
                  {
                    key: "option",
                    fn: function(option) {
                      return [
                        _vm._v(
                          "\n                    " +
                            _vm._s(option.title) +
                            " (#" +
                            _vm._s(option.requisition_id) +
                            ", " +
                            _vm._s(
                              option.requisition.person_specification
                                .business_line.company.title
                            ) +
                            ")\n                "
                        )
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.recycleJob,
                  callback: function($$v) {
                    _vm.recycleJob = $$v
                  },
                  expression: "recycleJob"
                }
              }),
              _vm._v(" "),
              _c("label", [_vm._v("Reason")]),
              _vm._v(" "),
              _c("vue-select", {
                attrs: {
                  label: "title",
                  name: "reason",
                  id: "reason",
                  options: _vm.reasons
                },
                scopedSlots: _vm._u([
                  {
                    key: "option",
                    fn: function(option) {
                      return [
                        _vm._v(
                          "\n                    " +
                            _vm._s(option.title) +
                            "\n                "
                        )
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.selectedOption,
                  callback: function($$v) {
                    _vm.selectedOption = $$v
                  },
                  expression: "selectedOption"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "grid-x grid-padding-x align-right" }, [
            _c("div", { staticClass: "cell shrink" }, [
              _c(
                "button",
                { staticClass: "button primary", attrs: { type: "submit" } },
                [_vm._v("Recycle")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cell shrink" }, [
              _c(
                "button",
                {
                  staticClass: "button warning",
                  attrs: { type: "button" },
                  on: { click: _vm.toggleModal }
                },
                [_vm._v("Close")]
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e1e1bd7", { render: render, staticRenderFns: staticRenderFns })
  }
}